const DOCUMENT_GROUP_ACTIONS = {
    EDIT: {
        text: 'edit',
        icon: 'mdi-lead-pencil'
    },
    CLONE: {
        text: 'clone',
        icon: 'mdi-content-copy'
    },
    DELETE:{
      text: 'delete',
      icon: 'mdi-delete'
    }
};
const DOCUMENT_GROUP_TYPES = {
    DOCUMENT:'DOCUMENT',
    REPORT: 'REPORT'
}
export {
    DOCUMENT_GROUP_ACTIONS,
    DOCUMENT_GROUP_TYPES
}